import Axios from "../../Config/API";

import { IIntegracoesDados } from "../../../Interfaces/Geral/Integracoes/IntegracoesInterface";
import Service from "../../Service";

export async function GetIntegracoesWhatsappService() {
    return Service(
        Axios.get<Array<IIntegracoesDados>>(
            `/home/integracoes/getintegracoeswhatsapp`
        )
    );
}

export async function InserirArquivoDriveService(idCaso: number, file: File) {
    const form = new FormData();
    form.append("file", file, file.name);
    return Service(
        Axios.post<string>(
            `/home/integracoes/inserirarquivodrive?idCaso=${idCaso}`,
            form
        )
    );
}
